import { defaultHotelBookS3 } from '../constants/generic';
import { S3FieldOptions } from '../ts/interfaces/Generic';

interface HotelBookRes {
  docket: S3FieldOptions;
  tourSubject: S3FieldOptions;
  passportNumber: S3FieldOptions;
  passportValidTill: S3FieldOptions;
  email: S3FieldOptions;
  phone: S3FieldOptions;
}

export const getHotelBookS3 = (other: any): HotelBookRes => {
  if (other) {
    const getS3FieldOptions = (key: string) => {
      let res = (defaultHotelBookS3 as any)[key];
      const displayKey = 'hotelBook_' + key + '_display';
      if (['0', '1', '2'].includes(other[displayKey]) && res) {
        res.display = other[displayKey];
      }

      const mandatoryKey = 'hotelBook_' + key + '_mandatory';
      if (['0', '1', '2'].includes(other[mandatoryKey]) && res) {
        res.mandatory = other[mandatoryKey];
      }

      if (other[displayKey] < other[mandatoryKey]) {
        res.mandatory = other[displayKey];
      }
      return res;
    };

    return {
      docket: getS3FieldOptions('docket'),
      tourSubject: getS3FieldOptions('tourSubject'),
      passportNumber: getS3FieldOptions('passportNumber'),
      passportValidTill: getS3FieldOptions('passportValidTill'),
      phone: getS3FieldOptions('phone'),
      email: getS3FieldOptions('email'),
    };
  } else {
    return defaultHotelBookS3;
  }
};
